@if (regionData?.result$ | async; as result) {
    @if (result.value?.data; as region) {
        <div class="search-container-details">
            <div class="tab-title-icon">
                <cll-icon class="tab-icon" type="outlined">layers</cll-icon>
                <div class="accordion-sub-title-accordion">
                    <span class="detail-table-title">Priorities</span>
                    <span class="detail-table-sub-title">Priorities associated with this region</span>
                </div>
            </div>
            <div>
                @if (region.status) {
                    @if ((user()?.permissions?.permissions ?? []).includes('region.create')) {
                        <button cll-icon-button cllSuffix (click)="addPriority()">
                            <cll-icon>add</cll-icon>
                        </button>
                    }

                }
            </div>
        </div>
        <div class="tabs-table-container">
            <table class="cll-table">
                <thead>
                <tr>
                    <th>Priorities</th>
                    <th>Delay (in minutes)</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    @if (region?.priorities; as priorities) {
                        @if (priorities.length > 0) {
                            @for (priority of priorities; track priority.id) {
                                <tr>
                                    <td>{{ priority.name }}</td>
                                    <td>{{ priority.delay }}</td>
                                    <td>{{ priority.description }}</td>
                                    <td>
                                        @if (priority.status) {
                                            <cll-badge colour="success">Active</cll-badge>
                                        } @else {
                                            <cll-badge colour="error">Inactive</cll-badge>
                                        }
                                    </td>
                                    <td class="align-right">
                                        @if ((user()?.permissions?.permissions ?? []).includes('region.update')) {
                                            <button cll-icon-button [cllMenuTriggerFor]="menu"
                                                    (click)="$event.stopPropagation()">
                                                <cll-icon>more_vert</cll-icon>
                                            </button>

                                            <ng-template #menu>
                                                <cll-menu>
                                                    @if (priority.status) {
                                                        @if (user()?.permissions?.permission_name?.includes('Administrator')) {
                                                            @if (region.status){
                                                                <button cllMenuItem (click)="editPriority(priority)">
                                                                    <cll-icon type="outlined">edit</cll-icon>
                                                                    Edit
                                                                </button>
                                                            }
                                                            <button cllMenuItem (click)="changeStatus(priority, false)">
                                                                <cll-icon type="outlined">toggle_off</cll-icon>
                                                                Mark as inactive
                                                            </button>
                                                        }
                                                    } @else {
                                                        @if (user()?.permissions?.permission_name?.includes('Administrator')) {
                                                            <button cllMenuItem (click)="changeStatus(priority, true)">
                                                                <cll-icon type="outlined">toggle_on</cll-icon>
                                                                Mark as active
                                                            </button>
                                                        }
                                                    }
                                                </cll-menu>
                                            </ng-template>
                                        }
                                    </td>
                                </tr>
                            }
                        } @else {
                            <tr>
                                <td colspan="5" class="no-data-row">
                                    <div class="no-data-wrapper-tabs">
                                        No priorities found.
                                    </div>
                                </td>
                            </tr>
                        }
                    }
                </tbody>
            </table>
        </div>
    }
}
